<!--desktop-->

<div class="desktop-wrapper t-scrollbar">
  <div
    class="wrapper"
    [class.is-rtl]="dir == 'rtl'"
    [class.is-ltr]="dir == 'ltr'"
  >
    <table
      class="tbl-summary"
      [class.is-new]="isNew"
      [class.edit-mode]="editMode"
    >
      <tbody>
        <tr class="tbl-header">
          <td>
            {{ "translate.general.orderIdMmd" | translate }}
          </td>
          <td>{{ "translate.general.clinic" | translate }}</td>
          <td>
            {{ "translate.general.doctor" | translate }}
          </td>
          <td *ngIf="!plantUserSw">
            {{ "translate.general.patient" | translate }}
          </td>
          <td>{{ "translate.general.orderDateFormatted" | translate }}</td>
          <td>
            <span *ngIf="clinicUserSw">{{
              "translate.general.clinicDueDateFormatted" | translate
            }}</span>
            <span *ngIf="!clinicUserSw">{{
              "translate.general.curDueDateFormatted" | translate
            }}</span>
          </td>
          <td>{{ "translate.general.stageDescr" | translate }}</td>
          <td *ngIf="displayUrgency">
            {{ "translate.general.urgency" | translate }}
          </td>
          <td *ngIf="displayAgent">
            {{ "translate.general.agent" | translate }}
          </td>
          <td *ngIf="displayTechnician">
            {{ "translate.general.technician" | translate }}
          </td>
          <td class="icon-header">
            <img src="assets\img\shade_white.svg" />
          </td>
          <td class="icon-header">
            <img src="assets\img\tik_white.svg" />
          </td>
          <td class="icon-header">
            <img src="assets\img\scan_white.svg" />
          </td>

          <td
            class="sticky-col last-col"
            [class.editable]="allowEdit"
            (click)="editMode || !allowEdit ? undefined : headerEditClicked()"
          >
            <div class="actions">
              <spinner *ngIf="saving"></spinner>
              <img
                *ngIf="!editMode && allowEdit && !saving"
                src="assets\img\icons\edit.svg"
              />
              <img
                *ngIf="editMode && !saving"
                src="assets\img\icons\x.svg"
                (click)="save($event)"
              />
              <img
                *ngIf="editMode && !saving"
                src="assets\img\icons\v.svg"
                (click)="cancelEdit($event)"
              />
            </div>
          </td>
        </tr>

        <tr class="tbl-data">
          <td>
            <strong>{{ currentOrder.displayId }}</strong>
          </td>
          <td>
            <div *ngIf="!editMode || closedSw">
              <span *ngIf="!plantUserSw">
                {{ currentOrder.clinicDescr }}
              </span>
              <span *ngIf="plantUserSw">
                {{ currentOrder.clinicId }}
              </span>
            </div>

            <div *ngIf="editMode && !closedSw">
              <p-select
                class="t-input--colored"
                #hasSearchDropdown
                [options]="clinicList"
                optionLabel="label"
                [(ngModel)]="editClinic"
                [filterPlaceholder]="'translate.general.search' | translate"
                [placeholder]="'translate.general.clinic' | translate"
                [filter]="true"
                filterBy="label,value.id"
                [resetFilterOnHide]="true"
                name="selectedClinic"
                [virtualScroll]="true"
                [virtualScrollItemSize]="30"
                appendTo="body"
                (onChange)="filterDoctors()"
              >
              </p-select>
            </div>
          </td>
          <td>
            <div *ngIf="!editMode || closedSw">
              <span *ngIf="!plantUserSw">
                {{ currentOrder.doctorFullName }}
              </span>
              <span *ngIf="plantUserSw">
                {{ currentOrder.doctorId }}
              </span>
            </div>

            <div *ngIf="editMode && !closedSw" class="l-align-center">
              <p-select
                class="t-input--colored"
                #hasSearchDropdown
                [options]="displayDoctorList"
                optionLabel="label"
                [(ngModel)]="editDoctor"
                [filterPlaceholder]="'translate.general.search' | translate"
                [placeholder]="'translate.general.doctor' | translate"
                [filter]="true"
                [resetFilterOnHide]="true"
                name="selectedDoctor"
                [virtualScroll]="true"
                [virtualScrollItemSize]="30"
                appendTo="body"
              >
              </p-select>
              <clear-multi
                *ngIf="editDoctor"
                (click)="editDoctor = null"
              ></clear-multi>
            </div>
          </td>

          <td *ngIf="!plantUserSw">
            <div *ngIf="!editMode || closedSw">
              {{ currentOrder.patientFullName }}
            </div>
            <div *ngIf="editMode && !closedSw">
              <input-wrap>
                <input
                  class="t-input t-input--colored"
                  type="text"
                  [(ngModel)]="editPatient"
                />
              </input-wrap>
            </div>
          </td>

          <td>
            <div *ngIf="!editMode || closedSw">
              {{ currentOrder.orderDateFormatted }}
            </div>
            <input-wrap *ngIf="editMode && !closedSw">
              <p-datepicker
                dateFormat="dd/mm/yy"
                [(ngModel)]="editOrderDate"
                [readonlyInput]="false"
                [locale]="calLocale"
                showButtonBar="true"
                appendTo="body"
                class="t-input--colored"
                [defaultDate]="defaultEditDate"
              ></p-datepicker>
            </input-wrap>
          </td>
          <td>
            <div *ngIf="!editMode">
              <span *ngIf="plantUserSw">
                {{ currentOrder.plantDueDateFormatted }}
              </span>
              <span *ngIf="clinicUserSw">
                {{ currentOrder.clinicDueDateFormatted }}
              </span>

              <span
                *ngIf="labUserSw"
                (mouseover)="op.show($event)"
                (mouseleave)="op.hide()"
              >
                {{ currentOrder.curDueDateFormatted }}
              </span>

              <span
                *ngIf="
                  currentOrder.origDueDateFormatted &&
                  currentOrder.curDueDateFormatted !==
                    currentOrder.origDueDateFormatted
                "
              >
                &nbsp;
                <i
                  class="fas fa-history t-pointer c1"
                  (mouseover)="opDD.show($event)"
                  (mouseleave)="opDD.hide()"
                ></i>
              </span>
            </div>
            <input-wrap *ngIf="editMode">
              <p-datepicker
                dateFormat="dd/mm/yy"
                [(ngModel)]="editDueDate"
                [readonlyInput]="false"
                [locale]="calLocale"
                showButtonBar="true"
                appendTo="body"
                class="t-input--colored"
                [defaultDate]="defaultEditDate"
              ></p-datepicker>
            </input-wrap>
          </td>
          <td>
            <order-stage-icon
              *ngIf="!editMode"
              [order]="currentOrder"
            ></order-stage-icon>
            <small
              *ngIf="!editMode && currentOrder.intake?.takerName"
              class="intake-taken-by"
              >{{ "translate.inbox.takenBy" | translate : { name: currentOrder.intake.takerName } }}</small
            >

            <div *ngIf="editMode">
              <p-select
                class="t-input--colored"
                #hasSearchDropdown
                [options]="stageList"
                optionLabel="label"
                [(ngModel)]="editStage"
                [filterPlaceholder]="'translate.general.search' | translate"
                [placeholder]="'translate.general.stage' | translate"
                [filter]="true"
                [filterBy]="'label,value.altFilter'"
                [resetFilterOnHide]="true"
                name="selectedStage"
                appendTo="body"
              >
              </p-select>
            </div>
          </td>
          <td *ngIf="displayUrgency">
            <order-urgency-icon [order]="currentOrder"></order-urgency-icon>
          </td>
          <td *ngIf="displayAgent">
            {{ currentOrder.agentDescr }}
          </td>
          <td *ngIf="displayTechnician">
            {{ currentOrder.technician }}
          </td>
          <td class="short-edit">
            <div *ngIf="!editMode">
              {{ currentOrder.shade || "-" }}
            </div>
            <div *ngIf="editMode">
              <input-wrap>
                <input
                  class="t-input t-input--colored"
                  type="text"
                  [(ngModel)]="editShade"
                />
              </input-wrap>
            </div>
          </td>
          <td>
            {{ currentOrder.ordTik || "-" }}
          </td>
          <td>
            <div *ngIf="!editMode">
              {{ currentOrder.ordScanNum || "-" }}
            </div>
            <div *ngIf="editMode">
              <input-wrap>
                <input
                  class="t-input t-input--colored"
                  type="text"
                  [(ngModel)]="editOrdScanNum"
                />
              </input-wrap>
            </div>
          </td>
          <td class="sticky-col last-col">
            <ng-container *ngTemplateOutlet="icons"></ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<p-popover #op class="opPanel">
  <div class="due-dates-container">
    <div>
      {{ "translate.order.clinicDueDate" | translate }}:
      <span class="fw-semibold">{{ currentOrder.clinicDueDateFormatted }}</span>
    </div>
    <div>
      {{ "translate.order.plantDueDate" | translate }}:
      <span class="fw-semibold">{{ currentOrder.plantDueDateFormatted }}</span>
    </div>
  </div>
</p-popover>

<p-popover #opDD class="opPanel">
  <div class="due-dates-container">
    <div>
      {{ "translate.order.prevDueDate" | translate }}:
      <span class="fw-semibold">{{ currentOrder.origDueDateForUser }}</span>
      &nbsp;&nbsp;
      {{ "translate.order.changeDate" | translate }}:
      <span class="fw-semibold">{{ currentOrder.dueDateChangeDate }}</span>
    </div>
    <div *ngIf="labUserSw">
      <div *ngFor="let a of currentOrder.dueDateChangeAccept">
        {{ "translate.order.changeAcceptedBy" | translate }}:
        <span class="fw-semibold">{{ a.userDescr }}</span>
        &nbsp;&nbsp;
        {{ "translate.order.changeAcceptDate" | translate }}:
        <span class="fw-semibold">{{ a.userAcceptDate }}</span>
      </div>
    </div>
  </div>
</p-popover>

<!--mobile-->

<table class="tbl-summary-mobile" [class.is-new]="isNew">
  <tbody>
    <tr>
      <td>{{ "translate.general.orderIdMmd" | translate }}</td>
      <td>
        <strong>{{ currentOrder.displayId }}</strong>
      </td>
    </tr>
    <tr>
      <td>{{ "translate.general.clinic" | translate }}</td>
      <td>
        <span *ngIf="!plantUserSw">
          {{ currentOrder.clinicDescr }}
        </span>
        <span *ngIf="plantUserSw">
          {{ currentOrder.clinicId }}
        </span>
      </td>
    </tr>
    <tr>
      <td>
        {{ "translate.general.doctor" | translate }}
      </td>
      <td>
        <span *ngIf="!plantUserSw">
          {{ currentOrder.doctorFullName }}
        </span>
        <span *ngIf="plantUserSw">
          {{ currentOrder.doctorId }}
        </span>
      </td>
    </tr>
    <tr *ngIf="!plantUserSw">
      <td>
        {{ "translate.general.patient" | translate }}
      </td>
      <td>{{ currentOrder.patientFullName }}</td>
    </tr>
    <tr>
      <td>{{ "translate.general.orderDateFormatted" | translate }}</td>
      <td>{{ currentOrder.orderDateFormatted }}</td>
    </tr>
    <tr>
      <td>
        <span *ngIf="clinicUserSw">{{
          "translate.general.clinicDueDateFormatted" | translate
        }}</span>
        <span *ngIf="!clinicUserSw">{{
          "translate.general.curDueDateFormatted" | translate
        }}</span>
      </td>
      <td>
        <span *ngIf="plantUserSw">
          {{ currentOrder.plantDueDateFormatted }}
        </span>
        <span *ngIf="clinicUserSw">
          {{ currentOrder.clinicDueDateFormatted }}
        </span>
        <span *ngIf="!clinicUserSw && !plantUserSw">
          {{ currentOrder.curDueDateFormatted }}
        </span>
      </td>
    </tr>
    <tr>
      <td>{{ "translate.general.stageDescr" | translate }}</td>
      <td>
        <order-stage-icon [order]="currentOrder"></order-stage-icon>
        <small *ngIf="currentOrder.intake?.takerName" class="intake-taken-by">{{ "translate.inbox.takenBy" | translate : { name: currentOrder.intake.takerName } }}</small>
      </td>
    </tr>
    <tr *ngIf="displayUrgency">
      <td>
        {{ "translate.general.urgency" | translate }}
      </td>
      <td>
        <order-urgency-icon [order]="currentOrder"></order-urgency-icon>
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <ng-container *ngTemplateOutlet="icons"></ng-container>
      </td>
    </tr>
    <tr *ngFor="let c of currentOrder.chatContacts">
      <td colspan="2" class="footer" (click)="onChatOpenClicked(c)">
        <div>
          <img src="assets\img\Chat.svg" />
          {{ "translate.chat.open" | translate }}
          &#8205;
          <span class="chat-title" [class.has-unread]="c.unreadCnt > 0">{{
            c.chatTitle | translate
          }}</span>
        </div>
      </td>
    </tr>
  </tbody>
</table>

<ng-template #icons>
  <div class="icons">
    <i
      class="fa-star icon-fav"
      [class.fas]="currentOrder.favoriteSw"
      [class.selected]="currentOrder.favoriteSw"
      [class.far]="!currentOrder.favoriteSw"
      (click)="onMarkFavorite()"
    ></i>

    <span *ngIf="currentOrder.leumitSw">{{
      "translate.general.leumit" | translate
    }}</span>

    <img
      *ngIf="currentOrder.inhouseSw"
      class="inhouse"
      src="assets\img\inhouse.svg"
      pTooltip=" {{ 'translate.general.inHouse' | translate }}"
      tooltipPosition="bottom"
    />
  </div>
</ng-template>

<!--order pref-->
<div *ngIf="currentOrder.drProfile || qcModeSw" class="info-container t-scrollbar">
  <order-profile-pref [order]="currentOrder"></order-profile-pref>
</div>
